'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionsFromFont = exports.getFontFromTheme = exports.isChartDataNotReady = exports.isChartNoData = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isChartNoData = exports.isChartNoData = R.anyPass([R.pipe(R.path(['data', 'series']), R.isEmpty), R.allPass([R.pipe(R.prop('type'), R.equals('ChoroplethChart'), R.not), R.pipe(R.path(['data', 'series', 0, 'datapoints']), R.anyPass([R.isNil, R.isEmpty]))])]);

var isChartDataNotReady = exports.isChartDataNotReady = R.pipe(R.path(['data', 'series']), R.isNil);

var getFontFromTheme = exports.getFontFromTheme = function getFontFromTheme(customPath) {
  return R.converge(R.mergeRight, [R.pathOr({}, ['mixins', 'chart', 'main']), R.pathOr({}, R.concat(['mixins', 'chart'], customPath))]);
};

var getOptionsFromFont = exports.getOptionsFromFont = R.pipe(R.props(['color', 'fontFamily', 'fontSize', 'fontWeight']), function (_ref) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 4),
      color = _ref2[0],
      family = _ref2[1],
      size = _ref2[2],
      weight = _ref2[3];

  return { color: color, size: size, family: family, weight: weight };
});